const charsCheck = /^[a-zA-Z\s]+$/;
const mobileCheck = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const numberCheck = /^[0-9]+$/;
const panCardCheck = /^[A-Z]{5}\d{4}[A-Z]$/;
const dunsCheck = /^\d{9}$/;
const gstinCheck = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d{1}[A-Z]\d{1}$/;
const tanCheck = /^[A-Z]{4}\d{5}[A-Z]$/;
const emailCheck = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const wordCheck = /\b\w+/g;
const whitespaceCheck = /\s+/g;
const specialCharacter = /[^A-Za-z0-9,]/g;
const specialCharacterWithComma = /[^\w,]/;
const nameCheck = /^[a-zA-Z0-9_\-\s]+$/;
const ruleNameCheck = /^[a-zA-Z][a-zA-Z0-9_\-\s]*$/;
// Regex to avoid all HTML/XML-like tags such as <>, <script>, <h1>, etc.
// This regex will fail (not match) if any tag-like pattern is present in the string.
const noTags = /^(?!.*<[^>]+>)(?!.*<>)(?!.*<).+$/;
const queryNameCheck = /^(?!.*\s{2,})[a-zA-Z0-9][a-zA-Z0-9_\-()/ ]*$/;
const regex = {
  charsCheck,
  mobileCheck,
  numberCheck,
  panCardCheck,
  dunsCheck,
  gstinCheck,
  tanCheck,
  emailCheck,
  wordCheck,
  whitespaceCheck,
  specialCharacter,
  specialCharacterWithComma,
  nameCheck,
  ruleNameCheck,
  noTags,
  queryNameCheck,
};

export default regex;
